exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".xs-add-codelist-form {\n  padding: 20px;\n}\n.xs-add-codelist-form .xs-actions {\n  margin-top: 5px;\n}\n.xs-add-codelist-form .xs-actions button:first-child {\n  margin-left: 0px;\n}\n", ""]);

// exports
